import { slices } from "@/constants/sliceNames";
import { createSlice } from "@reduxjs/toolkit";
import {
  requestAssetsStatus,
  requestDeleteSingleAssetStatus,
  requestSingleAssetStatus,
  requestUploadAssetStatus,
} from "../effects/assets-effects";

const initialState = {
  assets: [],
  recordsCount: 0,
  loading: false,
  asset: {},
};

const assetsSlice = createSlice({
  name: slices.assets,
  initialState,
  extraReducers: {
    ...requestAssetsStatus,
    ...requestDeleteSingleAssetStatus,
    ...requestSingleAssetStatus,
    ...requestUploadAssetStatus,
  },
});

const { actions, reducer } = assetsSlice;

export { actions };

export default reducer;
